module.exports = __webpack_public_path__ + "static/media/PT.311a181d.png";